import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const DplSidebarLinks = ({ isCollapsed }) => {
  const location = useLocation();
  return (
    <>
      {/* Dashboard */}
      <NavLink
        to='/dpl/home'
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Dashboard' : ''}
      >
        <i className='bi bi-house-fill'></i>
        <span className='sidebar-collapsed-text'>Dashboard</span>
      </NavLink>

      {/* Monitor VECI */}
      <NavLink
        to='/dpl/monitoring-veci'
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Monitor VECI' : ''}
      >
        <i className='bi bi-clipboard-data-fill'></i>
        <span className='sidebar-collapsed-text'>Monitor VECI</span>
      </NavLink>

      {/* Monitor BMC */}
      <NavLink
        to='/dpl/monitoring-bmc'
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Monitor BMC' : ''}
      >
        <i className='bi bi-kanban-fill'></i>
        <span className='sidebar-collapsed-text'>Monitor BMC</span>
      </NavLink>

      {/* Eskalasi */}
      <NavLink
        to='/dpl/escalations'
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Eskalasi' : ''}
      >
        <i className='bi bi-megaphone-fill'></i>
        <span className='sidebar-collapsed-text'>Eskalasi</span>
      </NavLink>
    </>
  );
};

export default DplSidebarLinks;
